import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Col, DatePicker, Input, Row } from 'antd';
import { useHistory } from 'react-router';
import { useForm, Controller, useFieldArray } from 'react-hook-form';

import { useDispatch } from 'react-redux';
import Breadcrumbs from '../Components/Breadcrumbs';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import GetField from '../Components/GetField';
import { clearCustomers, getCustomers } from '../Actions';
import StyleForm from './StyleForm';

const AntDatePicker = GetField(DatePicker);

const AntInputTextArea = GetField(Input.TextArea);

const CreateWorkerIssueForm = props => {
  const { classes } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control, watch, unregister, getValues, setValue } =
    useForm({
      defaultValues: {
        issueTime: new Date().toISOString(),
        styles: [
          {
            customerId: null,
            jobchartId: null,
            productId: null,
            styleId: null,
            baseColorId: null,
            printColorId: null,
            embroideryColorId: null,
            quantity: null,
            price: null,
            total: null,
          },
        ],
      },
    });

  const [confirmLoading, setConfirmLoading] = useState(false);

  const {
    fields: styleFields,
    append: styleAppend,
    remove: styleRemove,
  } = useFieldArray({
    control,
    name: 'styles',
  });

  useEffect(() => {
    dispatch(getCustomers());

    return () => {
      dispatch(clearCustomers());
    };
  }, []);

  const onSubmit = async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post('/worker-jobs/issues', formValues);
      successNotification('Style Issue form submitted');
      history.push('/workers/issues');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  };

  return (
    <>
      <Breadcrumbs
        moduleName="Worker Style Issues"
        moduleLink="/workers/issues"
        subModuleName="Add"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="issueTime"
              control={control}
              render={({ field }) => (
                <AntDatePicker
                  allowClear
                  showTime
                  label="Date & Time"
                  placeholder="Date & Time"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="remark"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <br />
        <Row>
          <Col className={classes.tableStyle}>
            <table className={classes.inputTable} style={{ width: 2500 }}>
              <thead className={classes.inputThead}>
                <tr>
                  <th className={classes.inputTh}>Customer</th>
                  <th className={classes.inputTh}>BPO #</th>
                  <th className={classes.inputTh}>Product</th>
                  <th className={classes.inputTh}>Style</th>
                  <th className={classes.inputTh}>Description</th>
                  <th className={classes.inputTh}>Size</th>
                  <th className={classes.inputTh}>Base Color</th>
                  <th className={classes.inputTh}>Print Color</th>
                  <th className={classes.inputTh}>Embroidery Color</th>
                  <th className={classes.inputTh}>Acid Wash Color</th>
                  <th className={classes.inputTh}>Jobchart Qty</th>
                  <th className={classes.inputTh}>Process</th>
                  <th className={classes.inputTh}>Quantity</th>
                  <th className={classes.inputTh}>Remark</th>
                  <th className={classes.inputTh} style={{ width: '6%' }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {styleFields.map((item, index) => (
                  <StyleForm
                    key={item.id}
                    styleItem={item}
                    styleIndex={index}
                    styleAppend={styleAppend}
                    styleRemove={styleRemove}
                    getValues={getValues}
                    setValue={setValue}
                    unregister={unregister}
                    control={control}
                    watch={watch}
                  />
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
        <br />
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

CreateWorkerIssueForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateWorkerIssueForm);
